import { c as _c } from "react/compiler-runtime";
import { IcoFaceid24, IcoIdCard24, IcoShield24, IcoUserstore24 } from '@onefootprint/icons';
import { BottomSheet, Button, Dialog } from '@onefootprint/ui';
import { motion } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next';
import { useMediaQuery } from 'usehooks-ts';
import { LEGACY_IDV_CONTAINER_ID as LAYOUT_CONTAINER_ID } from '@/idv2/components/constants';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import HeaderTitle from '../../../components/header-title';
import StickyBottomBox from '../../../components/sticky-bottom-box';
import ConsentText from './components/consent-text';
import MergedLogos from './components/merged-logos';
const mediaBreakpoints = {
  md: '900px'
};
type ConsentViewProps = {
  variant?: 'document' | 'selfie';
  isMobileDevice: boolean;
  tenantLogoUrl?: string;
  tenantName: string;
  tenantPrivacyPolicyUrl?: string;
  isLoading: boolean;
  consentTextOpen: boolean;
  onAgree: () => void;
  onNavigatedToPrev: () => void;
  onOpenConsentText: () => void;
  onCloseConsentText: () => void;
};
const ConsentView = t0 => {
  const $ = _c(100);
  const {
    variant: t1,
    isMobileDevice,
    tenantLogoUrl,
    tenantName,
    tenantPrivacyPolicyUrl,
    isLoading,
    consentTextOpen,
    onAgree,
    onNavigatedToPrev,
    onOpenConsentText,
    onCloseConsentText
  } = t0;
  const variant = t1 === undefined ? "document" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow.id-doc.pages.consent"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  const isMobile = useMediaQuery(`(max-width: ${mediaBreakpoints.md})`);
  const t3 = tenantPrivacyPolicyUrl ? "document-flow.id-doc.pages.consent.privacy-policy-text-with-tenant" : "document-flow.id-doc.pages.consent.privacy-policy-text-without-tenant";
  let t4;
  if ($[1] !== tenantName) {
    t4 = {
      tenantName
    };
    $[1] = tenantName;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onOpenConsentText) {
    t5 = e => {
      if (e.key === "Enter") {
        e.preventDefault();
        onOpenConsentText();
      }
    };
    $[3] = onOpenConsentText;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onOpenConsentText || $[6] !== t5) {
    t6 = <span role="button" tabIndex={0} className="text-secondary underline cursor-pointer" onClick={onOpenConsentText} onKeyDown={t5} />;
    $[5] = onOpenConsentText;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = t(_temp);
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t) {
    t8 = t(_temp2);
    $[10] = t;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t8) {
    t9 = <span className="sr-only">{t8}</span>;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t9) {
    t10 = <a className="text-secondary underline cursor-pointer" href="https://www.onefootprint.com/privacy-policy" rel="noopener noreferrer" target="_blank" aria-label={t7}>{t9}</a>;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `Read ${tenantName}'s Privacy Policy`;
  let t12;
  if ($[17] !== t || $[18] !== tenantName) {
    t12 = t(_temp3, {
      tenantName
    });
    $[17] = t;
    $[18] = tenantName;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <span className="sr-only">{t12}</span>;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t11 || $[23] !== t13 || $[24] !== tenantPrivacyPolicyUrl) {
    t14 = <a className="text-secondary underline cursor-pointer" href={tenantPrivacyPolicyUrl} rel="noopener noreferrer" target="_blank" aria-label={t11}>{t13}</a>;
    $[22] = t11;
    $[23] = t13;
    $[24] = tenantPrivacyPolicyUrl;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t10 || $[27] !== t14 || $[28] !== t6) {
    t15 = {
      bottomsheet: t6,
      fpPrivacyPolicy: t10,
      tenantPrivacyPolicy: t14
    };
    $[26] = t10;
    $[27] = t14;
    $[28] = t6;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t3 || $[32] !== t4) {
    t16 = <p className="text-caption-1 text-quaternary text-center"><Trans ns="idv2" i18nKey={t3} values={t4} components={t15} /></p>;
    $[30] = t15;
    $[31] = t3;
    $[32] = t4;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t(_temp4);
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== isLoading || $[37] !== onAgree || $[38] !== t17) {
    t18 = <Button fullWidth={true} size="large" onClick={onAgree} loading={isLoading}>{t17}</Button>;
    $[36] = isLoading;
    $[37] = onAgree;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t16 || $[41] !== t18) {
    t19 = <div className="flex flex-col gap-3 items-center">{t16}{t18}</div>;
    $[40] = t16;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  const buttonContent = t19;
  let t20;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 0
    };
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  let t22;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      opacity: 1,
      transition: {
        duration: 0.3
      }
    };
    t22 = {
      opacity: 0
    };
    $[44] = t21;
    $[45] = t22;
  } else {
    t21 = $[44];
    t22 = $[45];
  }
  let t23;
  if ($[46] !== onNavigatedToPrev) {
    t23 = <NavigationHeader leftButton={{
      variant: "back",
      onBack: onNavigatedToPrev
    }} />;
    $[46] = onNavigatedToPrev;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== tenantLogoUrl || $[49] !== tenantName) {
    t24 = <MergedLogos tenantLogoUrl={tenantLogoUrl} tenantName={tenantName} />;
    $[48] = tenantLogoUrl;
    $[49] = tenantName;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] !== t || $[52] !== tenantName) {
    t25 = t(_temp5, {
      tenantName
    });
    $[51] = t;
    $[52] = tenantName;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t) {
    t26 = t(_temp6);
    $[54] = t;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t25 || $[57] !== t26) {
    t27 = <HeaderTitle title={t25} subtitle={t26} display="flex" flexDirection="column" />;
    $[56] = t25;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== variant) {
    t28 = <div className="shrink-0">{variant === "selfie" ? <IcoFaceid24 color="primary" /> : <IcoIdCard24 color="primary" />}</div>;
    $[59] = variant;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== isMobileDevice || $[62] !== t || $[63] !== variant) {
    t29 = variant === "selfie" ? t(_temp7) : t($_6 => isMobileDevice ? $_6["take-a-photo"] : $_6["upload-a-photo"]);
    $[61] = isMobileDevice;
    $[62] = t;
    $[63] = variant;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== t29) {
    t30 = <p className="text-label-2 text-primary mt-0.5">{t29}</p>;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t28 || $[68] !== t30) {
    t31 = <div className="flex flex-row gap-2 items-start">{t28}{t30}</div>;
    $[67] = t28;
    $[68] = t30;
    $[69] = t31;
  } else {
    t31 = $[69];
  }
  let t32;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="shrink-0"><IcoUserstore24 color="primary" /></div>;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== t) {
    t33 = t(_temp8);
    $[71] = t;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== t33) {
    t34 = <div className="flex flex-row gap-2 items-start">{t32}<p className="text-label-2 text-primary mt-0.5">{t33}</p></div>;
    $[73] = t33;
    $[74] = t34;
  } else {
    t34 = $[74];
  }
  let t35;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <div className="shrink-0"><IcoShield24 color="primary" /></div>;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t || $[77] !== tenantName) {
    t36 = t(_temp9, {
      tenantName
    });
    $[76] = t;
    $[77] = tenantName;
    $[78] = t36;
  } else {
    t36 = $[78];
  }
  let t37;
  if ($[79] !== t36) {
    t37 = <div className="flex flex-row gap-2 items-start">{t35}<p className="text-label-2 text-primary mt-0.5">{t36}</p></div>;
    $[79] = t36;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t31 || $[82] !== t34 || $[83] !== t37) {
    t38 = <div className="flex flex-col w-full gap-5">{t31}{t34}{t37}</div>;
    $[81] = t31;
    $[82] = t34;
    $[83] = t37;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== t24 || $[86] !== t27 || $[87] !== t38) {
    t39 = <div className="flex flex-col items-center gap-6">{t24}{t27}{t38}</div>;
    $[85] = t24;
    $[86] = t27;
    $[87] = t38;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== consentTextOpen || $[90] !== isMobile || $[91] !== onCloseConsentText) {
    t40 = isMobile ? <BottomSheet open={consentTextOpen} onClose={onCloseConsentText} containerId={LAYOUT_CONTAINER_ID}><ConsentText /></BottomSheet> : <Dialog open={consentTextOpen} onClose={onCloseConsentText} title=""><ConsentText /></Dialog>;
    $[89] = consentTextOpen;
    $[90] = isMobile;
    $[91] = onCloseConsentText;
    $[92] = t40;
  } else {
    t40 = $[92];
  }
  let t41;
  if ($[93] !== buttonContent) {
    t41 = <StickyBottomBox>{buttonContent}</StickyBottomBox>;
    $[93] = buttonContent;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t23 || $[96] !== t39 || $[97] !== t40 || $[98] !== t41) {
    t42 = <motion.div className="flex flex-col flex-1 h-full" initial={t20} animate={t21} exit={t22}>{t23}{t39}{t40}{t41}</motion.div>;
    $[95] = t23;
    $[96] = t39;
    $[97] = t40;
    $[98] = t41;
    $[99] = t42;
  } else {
    t42 = $[99];
  }
  return t42;
};
export default ConsentView;
function _temp($) {
  return $["read-privacy-policy"];
}
function _temp2($_0) {
  return $_0["footprint-privacy-policy"];
}
function _temp3($_1) {
  return $_1["tenant-privacy-policy"];
}
function _temp4($_2) {
  return $_2["agree-and-continue"];
}
function _temp5($_3) {
  return $_3.title;
}
function _temp6($_4) {
  return $_4.subtitle;
}
function _temp7($_5) {
  return $_5["take-a-selfie"];
}
function _temp8($_7) {
  return $_7["footprint-securely-verifies"];
}
function _temp9($_8) {
  return $_8["your-data-encrypted"];
}